import { render } from "./ManageKnowledgebase.vue?vue&type=template&id=00ae9e6e&ts=true"
import script from "./ManageKnowledgebase.vue?vue&type=script&lang=ts"
export * from "./ManageKnowledgebase.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__